import { render } from "./HomeView.vue?vue&type=template&id=16054e1c"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lecof\\Projects\\Uni\\shu-pose-demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__